import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, RefreshCw } from "lucide-react";
import axios from "axios";

export default function ZohoCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("processing"); // processing, success, error
  const [message, setMessage] = useState("Connecting to Zoho CRM...");

  useEffect(() => {
    handleCallback();
  }, []);

  const handleCallback = async () => {
    try {
      const code = searchParams.get("code");
      const state = searchParams.get("state"); // companyId
      const location = searchParams.get("location");
      const error = searchParams.get("error");

      if (error) {
        setStatus("error");
        setMessage(`Authorization failed: ${error}`);
        setTimeout(() => navigate("/settings"), 3000);
        return;
      }

      if (!code || !state) {
        setStatus("error");
        setMessage("Missing authorization code or state parameter");
        setTimeout(() => navigate("/settings"), 3000);
        return;
      }

      setMessage("Exchanging authorization code for access tokens...");

      const response = await axios.post("/api/zoho/callback", {
        code,
        state,
        location: location || "US",
      });

      setStatus("success");
      setMessage(response.data.message || "Zoho CRM connected successfully!");

      setTimeout(() => {
        navigate("/settings");
      }, 2000);
    } catch (error) {
      console.error("Callback error:", error);
      setStatus("error");
      setMessage(
        error.response?.data?.message ||
          "Failed to connect Zoho CRM. Please try again."
      );
      setTimeout(() => navigate("/settings"), 3000);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        {status === "processing" && (
          <>
            <RefreshCw className="w-16 h-16 text-blue-600 mx-auto mb-4 animate-spin" />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Connecting...
            </h2>
            <p className="text-gray-600">{message}</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle2 className="w-10 h-10 text-green-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Success!</h2>
            <p className="text-gray-600">{message}</p>
            <p className="text-sm text-gray-500 mt-4">
              Redirecting to integrations page...
            </p>
          </>
        )}

        {status === "error" && (
          <>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <XCircle className="w-10 h-10 text-red-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Connection Failed
            </h2>
            <p className="text-gray-600">{message}</p>
            <p className="text-sm text-gray-500 mt-4">
              Redirecting back to integrations page...
            </p>
          </>
        )}
      </div>
    </div>
  );
}
